<template>
  <div class="activity-toast">
    <!-- <van-popup v-model="$store.state.nutritionClock.showActivityToast" @close="bindClose">
        <div class="toast">
            <img src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a882655068c2d3529228dabac23f1cb6.png" @click="bindJump" alt="">
        <div class="close iconfont icon-cha" @click="bindClose"></div>
        </div>
        </van-popup> -->
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      showToast: true
    }
  },
  created() {},
  methods: {
    bindClose() {
      this.$store.commit('nutritionClock/setShowActivityToast', false)
    },
    bindJump() {
      let url = 'http://t.weimob.com/AS_N4cC'
      this.$betterwe.jumpRoute(
        '/wmOtherPage?fromType=11&url=' +
          encodeURIComponent(url) +
          '&title=惊喜福利'
      )
    }
  }
}
</script>
<style lang="scss" scoped>
.activity-toast {
  ::v-deep .van-popup {
    background-color: transparent;
    overflow-y: visible;
  }
}
.toast {
  position: relative;
  width: 335px;
  img {
    width: 100%;
  }
  .close {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    transform: translate(-50%, -50%);
    color: #fff;
    border: 1px solid #fff;
    position: absolute;
    left: 50%;
    bottom: -50px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
